/**
 * Notification that the teacher has assigned a subject-mastery assignment
 * (AKA a course-mastery goal)
 */
import {plural, t} from "@lingui/core/macro";
import * as React from "react";

import BaseToastNotification from "../components/base-toast-notification.tsx";

// NOTE (josh): The type for this should be `StudentList` from
// class-package/types, but I can't use that type without adding a really
// expensive dependency.
// I've recreated it here, but we should really just use that type, in a
// post-webpack world.
type StudentListCopy = {
    id: string;
    name: string;
    signupCode: string;
    countStudents: number;
};

type Props = {
    studentList: StudentListCopy;
    numOfAssignedStudents: number;
};

export default ({
    studentList,
    numOfAssignedStudents,
}: Props): React.ReactElement => {
    const studentListName = studentList.name;
    const href = `/teacher/class/${studentList.signupCode}/manage-assignments`;

    const assignedToEntireClass =
        numOfAssignedStudents === studentList.countStudents;

    const message = assignedToEntireClass
        ? t`Course mastery goal created for all students in "${studentListName}"`
        : plural(numOfAssignedStudents, {
              one: `Course mastery goal created for # student in "${studentListName}."`,
              other: `Course mastery goal created for # students in "${studentListName}."`,
          });

    return (
        <BaseToastNotification
            linkText={t`View in Manage Mastery Goals`}
            href={href}
        >
            {message}
        </BaseToastNotification>
    );
};
